import React from "react";

export default function Spacer() {
    return <div style={{ flex: 1 }} />;
}
